//#region imports
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mobileProgressBarModel, ProgressBarModel } from '../shared/model/progressbar.model';
import { ProgressBarService } from './progressbar.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DetailsComponentModel } from '../module/details/details.model';
import { AppConstants } from '../app.constants';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class DetailsService {
  //#region variables
  detailsCurrentPage: string;
  disableDetailsNext = new Subject<boolean>();
  validateDetailsNext = new Subject<boolean>();
  private detailsSection: string;
  private detailsSectionFromGuarantee = new Subject<boolean>();
  private detailsComponent = new BehaviorSubject<DetailsComponentModel>(null);
  //#endregion

  //#region methods
  constructor(
    private progressBarService: ProgressBarService, private httpClient: HttpClient) { }

  setDetailsCurrentPage(
    firstPage: boolean, SecondPage: boolean, thirdPage: boolean, fourthPage: boolean, fifthPage: boolean,
    sixthPage: boolean, seventhPage: boolean, eightPage: boolean, ninthPage: boolean, tenthPage: boolean,
    eleventhPage: boolean, twelvethPage: boolean) {
    const detailsComponent = {
      DetailsQuestion1: firstPage, DetailsQuestion2: SecondPage, DetailsQuestion3: thirdPage,
      DetailsQuestion4: fourthPage, DetailsQuestion5: fifthPage, DetailsQuestion6: sixthPage,
      DetailsQuestion7: seventhPage, DetailsQuestion8: eightPage, DetailsQuestion9: ninthPage,
      DetailsQuestion10: tenthPage, DetailsQuestion11: eleventhPage, DetailsQuestion12: twelvethPage
    };
    this.setDetailsComponent(detailsComponent);
  }

  setDetailsSection(value: string) {
    this.detailsSection = value;
  }

  getDetailsSection() {
    return this.detailsSection;
  }

  setDisableDetailsNext(value: boolean) {
    this.disableDetailsNext.next(value);
  }

  getDisableDetailsNext(): Observable<boolean> {
    return this.disableDetailsNext.asObservable();
  }

  setvalidateDetailsNext(value: boolean) {
    this.validateDetailsNext.next(value);
  }

  getvalidateDetailsNext(): Observable<boolean> {
    return this.validateDetailsNext.asObservable();
  }

  setDetailsSectionFromGuarantee(value: boolean) {
    this.detailsSectionFromGuarantee.next(value);
  }

  getDetailsSectionFromGuarantee(): Observable<boolean> {
    return this.detailsSectionFromGuarantee.asObservable();
  }

  setDetailsComponent(value: DetailsComponentModel) {
    this.detailsComponent.next(value);
  }

  getDetailsComponent(): Observable<DetailsComponentModel> {
    return this.detailsComponent.asObservable();
  }

  getDetailsData(sectionKey, questionGroup) {
    const jsonData = JSON.parse(sessionStorage.getItem('jsonData'));
    const sections = jsonData.Sections.find(obj => obj.SectionKey === sectionKey);
    const quesGroup = sections.QuestionGroup.filter(obj => obj.GroupKey === questionGroup);
    const questChoices = quesGroup[0].Questions.map(obj => obj.QuestionChoices);
    return questChoices;
  }

  getDetailsQuestion(sectionKey, questionGroup) {
    const jsonData = JSON.parse(sessionStorage.getItem('jsonData'));
    const sections = jsonData.Sections.find(obj => obj.SectionKey === sectionKey);
    const quesGroup = sections.QuestionGroup.filter(obj => obj.GroupKey === questionGroup);
    const questions = quesGroup[0].Questions;
    return questions;
  }

  setDetailsProgressBarDetails() {
    const characteristicsProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: true
    };
    const detailsProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: false
    };
    const guaranteeProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    const summaryProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    const signatureProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    this.progressBarService.setCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setSignatureProgressStatus(signatureProgressStatus);
  }

  setmobileDetailsProgressBarDetails() {
    const characteristicsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const detailsProgressStatus: mobileProgressBarModel = {
      Enable: true
    };
    const guaranteeProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const summaryProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const signatureProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    this.progressBarService.setmobileCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setmobileDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setmobileGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setmobileSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setmobileSignatureProgressStatus(signatureProgressStatus);
    if (document.getElementById("tab1") !== null && document.getElementById("tab1") !== undefined 
    && document.getElementById("tab2") !== null && document.getElementById("tab2") !== undefined
    && document.getElementById("tab3") !== null && document.getElementById("tab3") !== undefined
    && document.getElementById("tab4") !== null && document.getElementById("tab4") !== undefined
    && document.getElementById("tab5") !== null && document.getElementById("tab5") !== undefined ){
    document.getElementById("tab1").classList.remove("d-none");
    document.getElementById("tab2").classList.remove("d-none");
    document.getElementById("tab3").classList.remove("d-none");
    document.getElementById("tab5").classList.remove("d-none");
    document.getElementById("tab4").querySelector(".panel-heading").classList.remove("d-none");
    }
  }
  getLocation() {
    const addressCode = 'Location';
    return this.httpClient.get<any>(environment.apiURL + AppConstants.APIURLS.GetAddress + addressCode);
  }

  getCountry() {
    const addressCode = 'Countries';
    // return this.httpClient.get<any>(environment.apiURL + AppConstants.APIURLS.GetAddress + addressCode);
    return this.httpClient.get<any>(environment.apiURL + AppConstants.APIURLS.GetCountry + addressCode);
    
  }
  //#endregion
}
